import format from '../plugins/baseFormat';
export default class StoreReport {
  constructor (initialData = {},) {
    const {
      store_id,
      name,
      orders_count,
      published,
      billing_plan,
      total_value,
    } = initialData;

    (this.store_id = store_id),
    (this.name = name),
    (this.checked = false),
    (this.orders_count = orders_count),
    (this.billing_plan = billing_plan),
    (this.total_value = total_value),
    (this.published = published);
  }

  get formatted_status () {
    return {
      true: 'Ativo',
      false: 'Inativo',
    }[this.published];
  }

  get formatted_billing_plan () {
    return {
      'NO_BILLING_PLAN': 'Nenhum',
    }[this.billing_plan];
  }

  get formatted_total_value () {
    if (this.total_value === null || this.total_value === undefined) {return '-';}
    return format.money(this.total_value,);
  }

}
